import { cn } from '@divlab/divanui';

import ServicePageWrapper from '@Components/ServicePageWrapper';
import CreditSlimBanner from '@Components/CreditSlimBanner';
import PartnersList from '../PartnersList';
import ExplanationsBlock from '../ExplanationsBlock';
import ListBlock from '../ListBlock/ListBlock';
import styles from './InstallmentDetails.module.css';

import type { InstallmentDetailsData } from '@Pages/PageCredit/typings';
import type { FC, HTMLAttributes } from 'react';

export interface InstallmentDetailsProps extends HTMLAttributes<HTMLDivElement> {
  data: InstallmentDetailsData;
  cnNotes?: string;
}

const InstallmentDetails: FC<InstallmentDetailsProps> = (props) => {
  const { className, data, cnNotes, ...restProps } = props;
  const { banner, info, notes, partners, description } = data;

  return (
    <div {...restProps} id={banner.id} className={cn(className, styles.container)}>
      {banner.view === 'slim' && <CreditSlimBanner banner={banner} cnPrefix={styles.prefix} />}

      <ServicePageWrapper>
        {description && (
          <ExplanationsBlock
            title={description.title}
            list={description.list}
            className={styles.descriptionList}
          />
        )}

        {info.map((infoData) => (
          <ListBlock
            className={styles.creditWithoutOverpayment}
            key={infoData.title}
            page={infoData}
          />
        ))}

        <div className={cn(styles.notes, cnNotes)}>
          {notes.map((note) => (
            <div key={note} className={styles.note}>
              {note}
            </div>
          ))}
        </div>

        {partners && (
          <div className={styles.partnersList}>
            <h2 className={styles.title}>{partners.title}</h2>
            <PartnersList list={partners.logos} />
          </div>
        )}
      </ServicePageWrapper>
    </div>
  );
};

export default InstallmentDetails;
